(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Kik-hotspot-image-text"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const video = document.getElementById('hotspotVideo');
  const image = document.getElementById('hotspotImage');
  const hotspots = document.querySelectorAll('.hotspot-point');

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting && video) {
        video.play().catch(() => {});
      }
    });
  }, { threshold: 0.3 });

  if (video) {
    observer.observe(video);
    video.addEventListener('ended', () => {
      video.style.display = 'none';
      if (image) image.style.display = 'block';
      hotspots.forEach(h => h.style.display = 'block');
    });
  } else {
    if (image) image.style.display = 'block';
    hotspots.forEach(h => h.style.display = 'block');
  }

  // Removed tooltip creation and hover logic

  hotspots.forEach(hotspot => {
    hotspot.addEventListener('click', () => {
      const title = hotspot.dataset.title || '';
      const text = hotspot.dataset.text || '';
      const button = hotspot.dataset.button || '';
      const link = hotspot.dataset.link || '';

      const titleEl = document.getElementById('hotspotTitle');
      const descEl = document.getElementById('hotspotDescription');
      const btnWrap = document.getElementById('hotspotButtonWrapper');

      if (titleEl) titleEl.innerHTML = `<strong>${title}</strong>`;
      if (descEl) descEl.textContent = text;

      if (btnWrap) {
        if (button && link) {
          btnWrap.innerHTML = `<a href="${link}" class="hotspot-btn">${button}</a>`;
        } else {
          btnWrap.innerHTML = '';
        }
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iw-countdown"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('iw-cd-timer')) {
  class IwCdTimer extends HTMLElement {
    connectedCallback() {
      const raw = this.dataset.end || '';
      const parts = raw.split('T');
      const dateParts = (parts[0] || '').split('-').map(Number);
      const timeParts = (parts[1] || '00:00').split(':').map(Number);
      const year = dateParts[0] || 0;
      const month = dateParts[1] || 1;
      const day = dateParts[2] || 1;
      const hour = timeParts[0] || 0;
      const minute = timeParts[1] || 0;
      this.endAt = new Date(year, month - 1, day, hour, minute, 0).getTime();
      this.hideWhenDone = this.dataset.hide === 'true';
      this.tick = this.tick.bind(this);
      this.tick();
      this.timer = setInterval(this.tick, 1000);
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }

    setUnit(name, value) {
      const els = this.querySelectorAll('[data-unit="' + name + '"]');
      if (!els.length) return;
      let str = String(Math.max(0, Math.floor(value)));
      while (str.length < els.length) str = '0' + str;
      if (str.length > els.length) {
        els[0].textContent = str.slice(0, str.length - els.length + 1);
        for (let i = 1; i < els.length; i++) {
          els[i].textContent = str[str.length - els.length + i];
        }
        return;
      }
      for (let i = 0; i < els.length; i++) {
        els[i].textContent = str[i];
      }
    }

    tick() {
      const distance = this.endAt - Date.now();
      if (distance <= 0) {
        this.setUnit('days', 0);
        this.setUnit('hours', 0);
        this.setUnit('minutes', 0);
        this.setUnit('seconds', 0);
        if (this.timer) clearInterval(this.timer);
        if (this.hideWhenDone) {
          const section = this.closest('.shopify-section');
          if (section) section.style.display = 'none';
        }
        return;
      }
      this.setUnit('days', Math.floor(distance / 86400000));
      this.setUnit('hours', Math.floor((distance % 86400000) / 3600000));
      this.setUnit('minutes', Math.floor((distance % 3600000) / 60000));
      this.setUnit('seconds', Math.floor((distance % 60000) / 1000));
    }
  }
  customElements.define('iw-cd-timer', IwCdTimer);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iw-product-showcase"] && !Shopify.designMode) return;
  try {
    
(function () {
  function bindIwPsForms(root) {
    var scope = root || document;
    var forms = scope.querySelectorAll('.iw-ps-card__form');
    forms.forEach(function (form) {
      if (form.dataset.iwPsAjax === 'true') return;
      form.dataset.iwPsAjax = 'true';
      if (window.theme && theme.AjaxProduct) {
        new theme.AjaxProduct(form, '.add-to-cart');
        return;
      }
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var btn = form.querySelector('.add-to-cart');
        var idInput = form.querySelector('[name="id"]');
        var id = idInput ? Number(idInput.value) : 0;
        if (!id) return;
        if (btn) btn.disabled = true;
        var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        })
          .then(function (res) {
            if (!res.ok) throw res;
            return res.json();
          })
          .then(function (added) {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: { product: added, addToCartBtn: btn },
              bubbles: true
            }));
            document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
          })
          .catch(function () {})
          .then(function () {
            if (btn) btn.disabled = false;
          });
      });
    });
  }

  bindIwPsForms();
  document.addEventListener('shopify:section:load', function (event) {
    bindIwPsForms(event.target);
  });
})();

if (!customElements.get('iw-ps-carousel')) {
  customElements.define('iw-ps-carousel', class IwPsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.iw-ps-carousel__track');
      this.nav = this.querySelector('.iw-ps-carousel__nav');
      this.prev = this.querySelector('.iw-ps-carousel__btn--prev');
      this.next = this.querySelector('.iw-ps-carousel__btn--next');
      this.slides = this.querySelectorAll('.iw-ps-carousel__slide');
      this.index = 0;
      if (!this.slides.length) return;
      if (this.slides.length > 1 && this.nav) this.nav.removeAttribute('hidden');
      if (this._bound) return;
      this._bound = true;
      var self = this;
      if (this.prev) this.prev.addEventListener('click', function () { self.go(-1); });
      if (this.next) this.next.addEventListener('click', function () { self.go(1); });
      this.addEventListener('touchstart', function (event) {
        self.startX = event.changedTouches[0].clientX;
      }, { passive: true });
      this.addEventListener('touchend', function (event) {
        if (typeof self.startX !== 'number') return;
        var dx = event.changedTouches[0].clientX - self.startX;
        if (Math.abs(dx) > 40) self.go(dx < 0 ? 1 : -1);
        self.startX = null;
      }, { passive: true });
    }

    go(dir) {
      var len = this.slides.length;
      if (len < 2) return;
      this.index = (this.index + dir + len) % len;
      this.style.setProperty('--iw-ps-carousel-i', String(this.index));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kiks-gallery-grid"] && !Shopify.designMode) return;
  try {
    
  class KiksGalleryGrid extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
  
    init() {
      this.gallery = this.querySelector('.kiks-gallery__grid');
      if (!this.gallery) return;
  
      // Check if we should initialize slider based on screen width
      this.checkAndInitSlider();
      
      // Listen for window resize
      window.addEventListener('resize', this.debounce(() => {
        this.checkAndInitSlider();
      }, 250));
    }
  
    checkAndInitSlider() {
      const isMobile = window.innerWidth <= 768;
      const desktopSliderEnabled = this.gallery.dataset.desktopSlider === 'true';
      const mobileSliderEnabled = this.gallery.dataset.mobileSlider === 'true';
      
      // Destroy existing Flickity instance if it exists
      if (this.slideshow && typeof this.slideshow.destroy === 'function') {
        this.slideshow.destroy();
        this.slideshow = null;
      }
  
      // Initialize slider if enabled for current screen size
      if ((isMobile && mobileSliderEnabled) || (!isMobile && desktopSliderEnabled)) {
        const slidesToShow = isMobile 
          ? parseInt(this.gallery.dataset.slidesShowMobile) 
          : parseInt(this.gallery.dataset.slidesShowDesktop);
  
        // Get navigation settings based on screen size
        const showArrows = isMobile 
          ? this.gallery.dataset.enableArrowsMobile === 'true'
          : this.gallery.dataset.enableArrowsDesktop === 'true';
        
        const showDots = isMobile
          ? this.gallery.dataset.enableDotsMobile === 'true'
          : this.gallery.dataset.enableDotsDesktop === 'true';
  
        const args = {
          cellAlign: 'left',
          contain: true,
          pageDots: showDots,
          prevNextButtons: showArrows,
          draggable: true,
          wrapAround: this.gallery.dataset.enableLoop === 'true',
          autoPlay: this.gallery.dataset.autoplaySpeed ? parseInt(this.gallery.dataset.autoplaySpeed) : false,
          groupCells: slidesToShow,
          cellSelector: '.grid__item'
        };
  
        this.slideshow = new theme.Slideshow(this.gallery, args);
      }
    }
  
    debounce(fn, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          fn(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }
  }
  
  customElements.define('kiks-gallery-grid', KiksGalleryGrid);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kiks-sticky-navbar"] && !Shopify.designMode) return;
  try {
    
  class KiksStickyNavbar extends HTMLElement {
    constructor() {
      super();
      this.navItems = this.querySelectorAll('[data-nav-item]');
      this.enableSticky = this.dataset.enableSticky === 'true';
      this.navbarTop = 0;
      this.mainContent = document.getElementById('MainContent');
      this.sections = [];
      this.maxSectionIndex = Math.max(
        ...Array.from(this.navItems).map(item => parseInt(item.getAttribute('data-section-index')) || 0)
      );

      this.lastScrollTop = 0;
      this._spacer = null;

      this.handleResize = this.handleResize.bind(this);
      this.handleScroll = this.handleScroll.bind(this);

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init());
      } else {
        this.init();
      }

      setTimeout(() => this.initSections(), 500);
    }

    initSections() {
      if (this.mainContent) {
        const allSections = Array.from(
          this.mainContent.querySelectorAll('.shopify-section, [id^="shopify-section"]')
        );

        const uniqueSections = allSections.filter(section => {
          const parent = section.parentElement.closest('.shopify-section, [id^="shopify-section"]');
          return !parent || parent === section;
        });

        uniqueSections.forEach((section, index) => {
          const sectionIndex = index + 1;
          section.setAttribute('data-nav-section-index', sectionIndex);
        });

        this.sections = uniqueSections;
      }
    }

    init() {
      this.initSections();
      this.setupEventListeners();
      this.checkActiveSection();

      if (this.enableSticky) {
        this.updateNavbarPosition();
        window.addEventListener('resize', this.handleResize);
      }
    }

    setupEventListeners() {
      this.navItems.forEach(item => {
        item.addEventListener('click', () => {
          const requestedIndex = parseInt(item.getAttribute('data-section-index'));
          const targetSection = this.sections[requestedIndex - 1];

          if (targetSection) {
            const header = document.querySelector('.site-header');
            const headerHeight = header ? header.offsetHeight : 0;
            const navbarHeight = this.offsetHeight;
            const totalOffset = headerHeight + (this.classList.contains('is-sticky') ? navbarHeight : 0);
            const targetPosition = this.getAbsoluteOffsetTop(targetSection) - totalOffset;

            window.scrollTo({
              top: targetPosition,
              behavior: 'smooth'
            });

            this.setActiveItem(item);
          } else {
            console.error(
              `Section ${requestedIndex} not found. Available sections:`,
              this.sections.map((s, i) => ({
                index: i + 1,
                id: s.id
              }))
            );
          }
        });
      });

      window.addEventListener('scroll', this.handleScroll);
    }

    handleScroll() {
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          this.checkActiveSection();

          if (this.enableSticky) {
            this.handleStickyBehavior();
            this.handleHeaderVisibility();
          }

          this.ticking = false;
        });

        this.ticking = true;
      }
    }

    handleHeaderVisibility() {
      if (!this.classList.contains('is-sticky')) {
        document.body.classList.remove('hide-main-header');
        return;
      }

      const currentScroll = window.pageYOffset;

      if (currentScroll > this.lastScrollTop) {
        document.body.classList.add('hide-main-header');
      } else if (currentScroll < this.lastScrollTop) {
        document.body.classList.remove('hide-main-header');
      }

      this.lastScrollTop = currentScroll;
    }

    handleStickyBehavior() {
      const scrollTop = window.pageYOffset;
      const header = document.querySelector('.site-header');
      const headerHeight = header ? header.offsetHeight : 0;

      if (scrollTop > (this.navbarTop - headerHeight - 1)) {
        if (!this.classList.contains('is-sticky')) {
          if (!this._spacer) {
            this._spacer = document.createElement('div');
            this._spacer.style.height = this.offsetHeight + 'px';
            this.parentNode.insertBefore(this._spacer, this.nextSibling);
          }
          this.classList.add('is-sticky');
          requestAnimationFrame(() => this.updateNavbarPosition());
        }
      } else {
        if (this.classList.contains('is-sticky')) {
          if (this._spacer) {
            this._spacer.remove();
            this._spacer = null;
          }
          this.classList.remove('is-sticky');
          requestAnimationFrame(() => this.updateNavbarPosition());
        }
      }
    }

    getAbsoluteOffsetTop(element) {
      let offsetTop = 0;
      while (element) {
        offsetTop += element.offsetTop;
        element = element.offsetParent;
      }
      return offsetTop;
    }

    handleResize() {
      if (this.enableSticky) {
        requestAnimationFrame(() => {
          this.updateNavbarPosition();
          this.handleStickyBehavior();
        });
      }
    }

    updateNavbarPosition() {
      const wasSticky = this.classList.contains('is-sticky');

      if (wasSticky) {
        this.classList.remove('is-sticky');
      }

      this.navbarTop = this.getBoundingClientRect().top + window.pageYOffset;

      if (wasSticky) {
        this.classList.add('is-sticky');
      }
    }

    checkActiveSection() {
      if (!this.sections.length) return;

      const header = document.querySelector('.site-header');
      const headerHeight = header ? header.offsetHeight : 0;
      const navbarHeight = this.offsetHeight;
      const totalOffset = headerHeight + (this.classList.contains('is-sticky') ? navbarHeight : 0);

      const viewportHeight = window.innerHeight;
      const viewportBottom = window.scrollY + viewportHeight;

      const visibilityData = this.sections.map((section, index) => {
        const rect = section.getBoundingClientRect();
        const sectionTop = window.scrollY + rect.top;
        const sectionHeight = rect.height;
        const sectionBottom = sectionTop + sectionHeight;

        const visibleTop = Math.max(sectionTop, window.scrollY + totalOffset);
        const visibleBottom = Math.min(sectionBottom, viewportBottom);
        const visibleHeight = Math.max(0, visibleBottom - visibleTop);
        const visibilityRatio = sectionHeight > 0 ? visibleHeight / sectionHeight : 0;

        return {
          index,
          section,
          sectionTop,
          sectionBottom,
          visibilityRatio,
          isInView: visibilityRatio > 0
        };
      });

      let mostVisibleSection = null;
      let maxVisibility = 0;

      visibilityData.forEach((data) => {
        if (data.isInView && data.visibilityRatio > maxVisibility) {
          maxVisibility = data.visibilityRatio;
          mostVisibleSection = data.section;
        }
      });

      if (window.scrollY <= 10) {
        mostVisibleSection = this.sections[0];
      }

      if ((window.innerHeight + window.scrollY) >= document.documentElement.scrollHeight - 10) {
        mostVisibleSection = this.sections[this.sections.length - 1];
      }

      if (mostVisibleSection) {
        const sectionIndex = this.sections.indexOf(mostVisibleSection) + 1;
        const activeNavItem = Array.from(this.navItems).find(
          item => parseInt(item.getAttribute('data-section-index')) === sectionIndex
        );

        if (activeNavItem) {
          this.setActiveItem(activeNavItem);
        }
      }
    }

    setActiveItem(activeItem) {
      if (!activeItem) return;

      this.navItems.forEach(item => {
        if (item !== activeItem && item.classList.contains('is-active')) {
          item.classList.remove('is-active');
        }
      });

      if (!activeItem.classList.contains('is-active')) {
        activeItem.classList.add('is-active');

        const navbarContainer = this.querySelector('.kiks-sticky-navbar__items');
        if (navbarContainer) {
          const containerWidth = navbarContainer.offsetWidth;
          const itemWidth = activeItem.offsetWidth;
          const itemLeft = activeItem.offsetLeft;
          const scrollLeft = itemLeft - (containerWidth / 2) + (itemWidth / 2);

          navbarContainer.scrollTo({
            left: scrollLeft,
            behavior: 'smooth'
          });
        }
      }
    }
  }

  customElements.define('kiks-sticky-navbar', KiksStickyNavbar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kiks-text-with-icons"] && !Shopify.designMode) return;
  try {
    
      class TextWithIconsSlider extends HTMLElement {
        constructor() {
          super();
          this.slider = null;
          this.init();
          this.handleResize = this.handleResize.bind(this);
        }

        getResponsiveOptions() {
          const windowWidth = window.innerWidth;
          let itemsToShow, itemsPerSlide;

          if (windowWidth <= 430) {
            // Mobile settings
            itemsToShow = parseInt(this.dataset.itemsToShowMobile) || 1;
            itemsPerSlide = parseInt(this.dataset.itemsPerSlideMobile) || 1;
          } else if (windowWidth <= 820) {
            // Tablet settings
            itemsToShow = parseInt(this.dataset.itemsToShowTablet) || 2;
            itemsPerSlide = parseInt(this.dataset.itemsPerSlideTablet) || 1;
          } else {
            // Desktop settings
            itemsToShow = parseInt(this.dataset.itemsToShow) || 3;
            itemsPerSlide = parseInt(this.dataset.itemsPerSlide) || 1;
          }

          return { itemsToShow, itemsPerSlide };
        }

        handleResize() {
          if (!this.slider) return;
          
          const { itemsToShow, itemsPerSlide } = this.getResponsiveOptions();
          
          // Update slider options
          this.slider.options.groupCells = itemsPerSlide;
          
          // Force slider refresh
          this.slider.resize();
          
          // Update cell widths
          const cells = this.slider.getCellElements();
          cells.forEach(cell => {
            cell.style.width = `calc(100% / ${itemsToShow})`;
          });
        }

        init() {
          const sliderEnabled = this.dataset.enableSlider === 'true';
          if (!sliderEnabled) return;

          const sliderContainer = this.querySelector('.text-with-icons__blocks');
          if (!sliderContainer) return;

          const { itemsToShow, itemsPerSlide } = this.getResponsiveOptions();

          const options = {
            cellAlign: 'left',
            contain: true,
            pageDots: true,
            prevNextButtons: true,
            wrapAround: this.dataset.enableLoop === 'true',
            autoPlay: this.dataset.enableAutoplay === 'true' ? parseInt(this.dataset.autoplaySpeed) : false,
            groupCells: itemsPerSlide,
            cellSelector: '.text-with-icons__block',
            adaptiveHeight: false,
            draggable: true
          };

          // Initialize Flickity
          this.slider = new Flickity(sliderContainer, options);

          // Add resize handler
          window.addEventListener('resize', this.handleResize);

          // Initial resize to set correct sizes
          this.handleResize();
        }

        disconnectedCallback() {
          window.removeEventListener('resize', this.handleResize);
          if (this.slider) {
            this.slider.destroy();
          }
        }
      }

      customElements.define('text-with-icons-slider', TextWithIconsSlider);
    
  } catch(e) { console.error(e); }
})();
})();
